import { fetchDramaInfo } from "../actions/drama";

async function fetchData({ dispatch, params }) {
  const { dramaId, id } = params;
  await dispatch(fetchDramaInfo(dramaId || id));
}

export default fetchData;
